import { render, staticRenderFns } from "./OfficialActiveActivityPay.vue?vue&type=template&id=ed54f40a&scoped=true"
import script from "./OfficialActiveActivityPay.vue?vue&type=script&lang=js"
export * from "./OfficialActiveActivityPay.vue?vue&type=script&lang=js"
import style0 from "./OfficialActiveActivityPay.vue?vue&type=style&index=0&id=ed54f40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed54f40a",
  null
  
)

export default component.exports